export const isGenericVar = (varName: string) => /^var\d+$/.test(varName);
